<template>
    <vx-table class="xl:grid-cols-4-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">Organizational Unit</div>
            <div>Team</div>
            <div>Team Status</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
